import { useNavigate } from 'react-router-dom';
import { Grid2 as Grid, Box, Stack, Typography, useTheme } from '@mui/material';
import { Facebook, X, LinkedIn, Instagram } from '@mui/icons-material';
import { EmailSubscriptionForm, HulaTechLogo, TooltipIconButton } from '../../shared/components';
import {
  homeQuickLinks,
  hulaLinks,
  responsivePagePadding,
  forLearnersQuickLinks,
  wcedSocialPagesLinks,
  aIToolsQuickLinks,
} from '../../shared/utils/constants';

const scrollToElementInMiddle = (elementId: string) => {
  const element = document.getElementById(elementId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    const offset = window.innerHeight / 2 - element.offsetHeight / 2; // Centering offset
    window.scrollTo({
      top: elementPosition - offset,
      behavior: 'smooth',
    });
  }
};

const TheFooter = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const iconWidthHeight = { md: '30px', lg: '40px' };

  const iconSx = {
    color: theme.palette.primary.main,
    fontSize: { md: '20px', lg: '25px' },
    width: iconWidthHeight,
    height: iconWidthHeight,
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: '32px 16px',
        width: '100%',
        height: 'auto',
      }}
    >
      <Grid container spacing={6} padding={responsivePagePadding}>
        <Grid size={{ xs: 12, sm: 5 }} spacing={4}>
          <Stack spacing={3}>
            <Typography variant="body1">
              Career Clubs is a joint initiative between the Western Cape Education Department and the Western Cape
              Department of Economic Development & Tourism in line with its Growth for Jobs Strategy.
            </Typography>
            <Stack
              direction="row"
              spacing={4}
              sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', md: 'flex-start' } }}
            >
              <TooltipIconButton icon={<Facebook sx={iconSx} />} path={wcedSocialPagesLinks.facebook} />
              <TooltipIconButton icon={<X sx={iconSx} />} path={wcedSocialPagesLinks.x} />
              <TooltipIconButton icon={<LinkedIn sx={iconSx} />} path={wcedSocialPagesLinks.linkedIn} />
              <TooltipIconButton icon={<Instagram sx={iconSx} />} path={wcedSocialPagesLinks.instagram} />
            </Stack>

            {/* Subscription Box */}
            <Box
              sx={{
                border: '1px solid white',
                borderRadius: 2,
                padding: 2,
                backgroundColor: theme.palette.utility.light,
              }}
            >
              <Typography variant="h5" color={theme.palette.primary.main}>
                Subscribe to our newsletter
              </Typography>
              <EmailSubscriptionForm />
            </Box>
          </Stack>
        </Grid>

        {/* Quick Links Section */}
        <Grid
          size={{ xs: 12, sm: 7 }}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            justifyContent: 'flex-start',
          }}
        >
          {/* Quick Links Header */}
          {/* <Typography variant="h5" sx={{ marginBottom: 2 }}>
            Quick Links
          </Typography> */}

          {/* Links Container */}
          <Grid
            container
            spacing={{ xs: 4, sm: 6, md: 8 }}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {/* Section 1 */}
            <Grid size={4}>
              <Stack spacing={2}>
                {homeQuickLinks.map((item, index) => (
                  <Typography
                    key={index}
                    variant="body2"
                    sx={{
                      cursor: 'pointer',
                      textDecoration: 'underline',
                      '&:hover': {
                        textDecoration: 'none',
                        color: theme.palette.primary.light,
                      },
                    }}
                    onClick={() => {
                      navigate(item.path);
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                  >
                    {item.text}
                  </Typography>
                ))}
              </Stack>
            </Grid>

            {/* Section 2 */}
            <Grid size={4}>
              <Stack spacing={2}>
                {forLearnersQuickLinks.map((item, index) => (
                  <Typography
                    key={index}
                    variant="body2"
                    sx={{
                      cursor: 'pointer',
                      textDecoration: 'underline',
                      '&:hover': { textDecoration: 'none', color: theme.palette.primary.light },
                    }}
                    onClick={() => {
                      navigate(item.path);
                      scrollToElementInMiddle(item.target);
                    }}
                  >
                    {item.text}
                  </Typography>
                ))}
              </Stack>
            </Grid>

            {/* Section 3 */}
            <Grid size={4}>
              <Stack spacing={2}>
                {aIToolsQuickLinks.map((item, index) => (
                  <Typography
                    key={index}
                    variant="body2"
                    sx={{
                      cursor: 'pointer',
                      textDecoration: 'underline',
                      '&:hover': { textDecoration: 'none', color: theme.palette.primary.light },
                    }}
                    onClick={() => window.open(item.path, '_blank')}
                  >
                    {item.text}
                  </Typography>
                ))}
              </Stack>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          size={12}
          sx={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={() => window.open(hulaLinks.hula, '_blank')}
          >
            <Typography variant="body2">Powered by</Typography>
            <HulaTechLogo variant="white" height="80px" width="100px" />
            <Typography variant="body2">Technology</Typography>
          </Box>
        </Grid>
      </Grid>
      <Typography variant="caption">© 2025 Hula Technology</Typography>
    </Box>
  );
};

export default TheFooter;
